'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Mediator = require('./../../../core/mediator');
const translator = require('./../../../core/translator');

const DefinitionManager = require('./../component/DefinitionManager');
const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const PopinManager = require('./../../../services/popin');
const DndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const Loader = require('./../../../services/loader');
const Help = require('./../../../services/help');

const windowContentTpl = require('./../template/window_content.hbs');

const getForbiddenDefinitionToAdd = function(categories) {
    let definitions = DefinitionManager.getAll();
    let result = [];
    let newCategories = _.clone(categories);

    _.forEach(definitions, function(definition) {
        if (definition.properties.unique_per_page) {
            if (jQuery('[data-bb-identifier^="' + definition.type + '"]').length) {
                result.push(definition.type);
            }
        }
    });

    _.forEach(newCategories, function(category) {
        _.forEach(category.contents, function(content) {
            content['is_forbidden'] = -1 !== result.indexOf(content.type);
        });
    });

    return categories;
};

module.exports.onClick = function(object) {
    let event = object.event;
    let categories = object.categories;
    let $parent = jQuery(event.target);
    let toolbar;
    let popin;

    if (!$parent.hasClass('cloud-insert')) {
        $parent = $parent.parents('.cloud-insert:first');
    }

    jQuery('.cloud-insert').each(function() {
        let $current = jQuery(this);

        if (!$parent.is($current)) {
            $current.remove();
        }
    });

    toolbar = jQuery(windowContentTpl({
        'categories': getForbiddenDefinitionToAdd(categories),
    }));

    toolbar.find('.thumbnail').each(function() {
        const $img = jQuery(this);
        const imgID = $img.attr('id');
        const imgClass = $img.attr('class');
        const imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            let $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
            }

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    popin = PopinManager.createPopin({
      'classes': {
        'ui-dialog': 'cloud-dialog content-dialog not-fixed add-content',
      },

        'title': translator.translate('add_content'),
        'width': jQuery(document).width() < 870 ? jQuery(document).width() - 40 : 870,
        'modal': false,
        'minHeight': 100,
        'draggable': false,
        'resizable': false,
        'appendTo': '#cloud-ui',
        'position': {my: 'center top', at: 'center top+40'},
        'closeOnScroll': false,
    });

    toolbar.find('.cloud-content-list li .btn').on('click', function() {
        let $current = jQuery(this);
        if (!$current.hasClass('disabled')) {
            Mediator.publish('content:add', {'popin': popin, 'type': $current.data('type'), '$zone': $parent.parent()});
        }
    });

    popin.setContent(toolbar);
    popin.display();

    popin.rootElement.parents('.ui-dialog').find('.ui-dialog-title').append(Help.createLink(`add_content`));

    popin.rootElement.on('dialogclose', function() {
        if ($parent.parent().hasClass('force-fixed')) {
            $parent.removeClass('fixed');
        } else {
            $parent.remove();
        }
    });

    $parent.addClass('fixed');
};

const afterGetHtml = function(content, contentSet, $html, $zone, object) {
    $html.insertBefore($zone);
    contentSet.setUpdated(true);

    SaveManager.save().done(function() {
        DndZone.apply();
        ResizeColumn.apply();
        Loader.stop();

        Mediator.publish('after:' + content.type + ':add', content);
        Mediator.publish('after:content:add', content);
    });
};

module.exports.onAdd = function(object) {
    let type = object.type;
    let $zone = object.$zone;
    let currentContentSet = ContentManager.getContentByNode($zone.parents('.bb-content:first'));
    let dataEvent;

    if (type && currentContentSet && currentContentSet.isContentSet()) {
        dataEvent = {
            'type': type,
        };

        Mediator.publish('before:' + type + ':add', dataEvent);
        Mediator.publish('before:content:add', dataEvent);

        Loader.start();
        DndZone.hideAll();
        object.popin.hide();

        if ($zone.hasClass('between')) {
            ContentManager.createElement(type).done(function(content) {
                let $colContentSet = $zone.parents('.bb-content:first');
                let colContentSet = ContentManager.getContentByNode($colContentSet);

                content.getHtml().done(function($html) {
                    afterGetHtml(content, colContentSet, $html, $zone, object);
                });
            });
        } else {
            ContentManager.createElementWithSub('ColContentSet', type).done(function(colContentSet, content) {
                ContentManager.createElement('CloudContentSet', {
                    'elements': [
                        {
                            'type': colContentSet.type,
                            'uid': colContentSet.uid,
                        },
                    ],
                }).done(function(cloudContentSet) {
                    cloudContentSet.getHtml().done(function($html) {
                        content.$ = $html.find('[data-bb-identifier^="' + content.type + '"]');
                        afterGetHtml(content, currentContentSet, $html, $zone, object);
                    });
                });
            });
        }
    }
};
